<template>
  <div>
    <api-list type="geofencesTrackingHistoryEvents" :model="models.geofencesTrackingHistoryEvents" :quick-filters="quickFiltersSetup.geofencesTrackingHistoryEvents" :preFilters="[['model_id', 'eq', item.id]]" no-querystring in-modal />
  </div>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ItemsTrackingHistoryEvents',
  components: {
    ApiList
  },
  props: {
    item: {
      type: null,
      default: null
    }
  }
}
</script>
